import { BlockWrapperProps } from './BlockWrapper';
import { getBlockSpacing } from './behaviour';
import theme from '../../lib/theme';

const { layouts, scale, media, colors } = theme;

export default ({
  type,
  desktop_spacing,
  mobile_spacing,
  background_colour,
}: BlockWrapperProps) => ({
  blockWrap: {
    backgroundColor: background_colour,
    //  do not apply padding to the bottom of the Title block
    padding: `${getBlockSpacing(mobile_spacing)} 0 ${
      type == 'acf_title_block' ? 0 : getBlockSpacing(mobile_spacing)
    } 0`,

    [media.s.up]: {
      padding: `${getBlockSpacing(desktop_spacing)} 0 ${
        type == 'acf_title_block' ? 0 : getBlockSpacing(desktop_spacing)
      } 0`,
    },
  },
});
